var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 11.5C7.78125 11.7812 7.78125 12.25 8.0625 12.5312L14.125 18.625C14.4375 18.9062 14.9062 18.9062 15.1875 18.625L15.9062 17.9062C16.1875 17.625 16.1875 17.1562 15.9062 16.8438L11.0938 12L15.9062 7.1875C16.1875 6.875 16.1875 6.40625 15.9062 6.125L15.1875 5.40625C14.9062 5.125 14.4375 5.125 14.125 5.40625L8.0625 11.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.024069b1c3f69fde8827666fa37f0e36.svg";
export { ForwardRef as ReactComponent };